import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
const config = require("../../../assets/appconfig/appconfig.json");

@Injectable({ providedIn: 'root' })
export class AppTranslateLoader implements TranslateLoader  {

  constructor(private httpClient: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.httpClient.get<any>(this.getBaseUrl() + `api/User/TranslateFile/${lang ||'en'}`);
  }

  /// getTranslation is executed before the constructor of app.component and 
  /// getting undefined if we fetch from another service.
  /// we have copied the method from main.ts file
  getBaseUrl():string {
    let url = config.APP.APISERVER;
    let subdomain =  this.getSubdomainFromUrl();
  
    if(url.includes('{subdomain}') && subdomain) {
      url = url.replace('{subdomain}', subdomain)
    }
    return url ?? config.APP.APISERVER;
  }

  getSubdomainFromUrl():string {
    let subDomain = "";
    const parsedUrl = new URL(window.location.href);
    const urlParts = parsedUrl.host.split('.', 1);
  
    if(urlParts.length > 0)
      subDomain = urlParts[0];
  
    return subDomain;
  }
}
